var map = {
	"./accessories.svg": 6786,
	"./bags.svg": 82113,
	"./clothing.svg": 56304,
	"./home-and-living.svg": 93509,
	"./home-decor.svg": 82185,
	"./paper.svg": 25458,
	"./store.svg": 28835,
	"./wall-art.svg": 2060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44138;